import { render, staticRenderFns } from "./DialogUser.vue?vue&type=template&id=06c8798a&"
import script from "./DialogUser.vue?vue&type=script&lang=ts&"
export * from "./DialogUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports